import { faBook } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useState } from "react"
import { Button } from "react-bootstrap"
import { toast } from "react-toastify"
import { createGradingPeriod } from "shared/routes/teacher"
import GradingPeriodForm from "./GradingPeriodForm"

interface Props {
    classId: string
}

const CreateGradingPeriodModal = ({ classId } : Props) => {
    const [show, setShow] = useState(false)

    if (!show) return <Button onClick={() => setShow(true)}> <FontAwesomeIcon icon={faBook} /> Add Grading Period</Button>

  return (
    <div>
        <Button onClick={() => setShow(true)}> <FontAwesomeIcon icon={faBook} /> Add Grading Period</Button>
        <GradingPeriodForm 
            type="create"
            classId={classId} 
            show={show} 
            onHide={() => setShow(false)} 
            onSubmit={async (periodName: string, assignmentIds: string[], classId: string) => {
                createGradingPeriod({ name: periodName, classId: classId, assignmentIds: assignmentIds })
                    .then(() => {
                        toast.success("Grading period created successfully.")
                    })
                    .catch(err => {
                        toast.error(err.response?.data?.message ?? "Failed to create grading period.")
                    })
                    .finally(() => {
                        setShow(false)
                    })
            }} />
    </div>
  )
}

export default CreateGradingPeriodModal
